export default function SectionTitleField({
  label, 
}) {
  return (
    <div className="mb-6">
      <h1 className="block text-lg font-semibold mb-1 text-gray-900">
        {label}
      </h1>
    </div>
  );
}
